import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalModule } from 'src/shared/modal';
import { CheckCreditDialogComponent } from './check-credit-dialog.component';
import { CheckCreditDialogService } from './check-credit-dialog.service';



@NgModule({
  providers: [CheckCreditDialogService],
  imports: [
    CheckCreditDialogComponent,
    CommonModule,
    ModalModule,
  ]
})
export class CheckCreditDialogModule { }
